import { program } from 'commander';
const VERSION = require('../package.json').version;

program
  .name('cryptowatch')
  .version(VERSION)
  .usage('-id bitcoin --currency USD --assets 200 --interval 30000 --verbose --sound')
  .option('-id, [assetId]', 'Token name.', 'bitcoin')
  .option('-c, --currency [string]', 'Fiat currency.', 'usd')
  .option('-a, --assets [integer]', 'Amount of owned tokens.', parseFloat, 0)
  .option('-i, --interval [ms]', 'How often to pull data in ms.', s => parseInt(s), 60000)
  .option('-v --verbose', "Log also when price hasn't changed", false)
  .option('--sound', 'Enable sound notifications on price change', false)
  .parse(process.argv);

export default program;
